import { render, staticRenderFns } from "./BacButton.vue?vue&type=template&id=126c0652&scoped=true&"
var script = {}
import style0 from "./BacButton.vue?vue&type=style&index=0&id=126c0652&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126c0652",
  null
  
)

export default component.exports